import * as type from '../store/types'

export default {
  methods: {
    // изменение модели
    setModel(name, model) {
      this.$store.commit(type.SET_MODEL, { name, model })
    },
    updateModel(name, model) {
      this.$store.commit(type.UPDATE_MODEL, { name, model })
    },

    // изменение параметров
    setParams(name, params) {
      this.$store.commit(type.SET_PARAMS, { name, params })
    },
    updateParams(name, params) {
      this.$store.commit(type.UPDATE_PARAMS, { name, params })
    },

    // изменение списка
    setList(name, list) {
      this.$store.commit(type.SET_LIST, { name, list })
    }
  }
}
